import { PROJECT_TEMPLATE_FILE } from "~/pages/ProjectTemplates/utils";
import Angie from "~/utils/angie";

const DropboxFileTypes = [`DropboxFile`, `DropboxAttachment`, `DropboxUploadedFile`];

const GoogleDriveFileTypes = [`GoogleDriveFile`, `GoogleDriveAttachment`, `GoogleDriveUploadedFile`];

const LocalFileTypes = [`LocalFile`, `LocalAttachment`, `LocalUploadedFile`];

const WarehouseFileTypes = [`WarehouseFile`, `WarehouseAttachment`, `WarehouseUploadedFile`];

const getType = (file) => {
  if (!file) return undefined;
  return file.class === PROJECT_TEMPLATE_FILE ? file.type : file.class;
};

class FileTrait {
  static isDropboxFile() {
    return DropboxFileTypes.indexOf(getType(this)) > -1;
  }

  static isGoogleDriveFile() {
    return GoogleDriveFileTypes.indexOf(getType(this)) > -1;
  }

  static isLocalFile() {
    return LocalFileTypes.indexOf(getType(this)) > -1;
  }

  static isWarehouseFile() {
    return WarehouseFileTypes.indexOf(getType(this)) > -1;
  }

  static getThumbnailUrl(width = 40, height = width, scale = `crop`) {
    if (!this.thumbnail_url) {
      return this.thumbnail_url;
    }

    let thumbnail_url = this.thumbnail_url
      .replace(`--WIDTH--`, width)
      .replace(`--HEIGHT--`, height)
      .replace(`--SCALE--`, scale)
      .replace("--THUMBNAIL-TOKEN--", Angie.file_access_token.thumb_token)
      .replace("--DOWNLOAD-TOKEN--", Angie.file_access_token.download_token);

    return thumbnail_url;
  }

  static getSize() {
    return this.sizeValue || 0;
  }
}

export default FileTrait;
